import { Typography } from '@mui/material';
import ClickablePhoneNumber from '../global/ClickablePhoneNumber';

type Props = {
  label: string;
  values: string[];
};

export default function SectionPhoneRow({ label, values }: Props) {
  return (
    <div className="section-row">
      <Typography variant="overline" component="p">
        {label}
      </Typography>
      {values.map((value, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <ClickablePhoneNumber number={value} key={index} />
      ))}
    </div>
  );
}
